import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Recycling_1: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			rotate: 0,
		},
		config: {
			duration: 1200,
		},
		onRest: (_, spring) => spring.set({ rotate: 0 }),
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ rotate: 360 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // all
					d="M217.08 58.38h.92c.58 0 1.14 0 1.73-.06a41.07 41.07 0 015 .05h.33l-.12.19c-1.08 0-2.36 0-3.77-.06 2.05.1 4 .27 5.78.48l-.07-.48c.76.06 1.53.14 2.31.25a.15.15 0 01.13 0c1.32.17 2.64.38 3.94.66a60.44 60.44 0 015.89 1.49 39.34 39.34 0 013.95 1.42 1.13 1.13 0 01.22.08h.1a58.2 58.2 0 0135.13 41c-1.62-.09-69.87-3.65-119.6 24.8 0 0 48.46-21.53 121.09-10a58.28 58.28 0 01-72.52 54.83 1.23 1.23 0 00-.24-.06 5.3 5.3 0 00-.57-.17c-.74-.25-2-.63-3.72-1.11-16.73-4.72-76.72-18.84-118 7.06 0 0 10.81-39.24 39.17-72.94a149.54 149.54 0 0121.74-21.2c.11-.11.23-.2.35-.3L148 83c25.79-20.3 51-24.84 69.08-24.62zM60.71 311.51c-.13-.25-.27-.48-.39-.7a.6.6 0 00-.06-.11c-.31-.49-.61-1-.92-1.47a41.42 41.42 0 01-2.42-4.33c-.05-.1-.12-.19-.16-.29H57c.52.95 1.15 2.07 1.83 3.3-.94-1.83-1.74-3.58-2.46-5.25L56 303c-.32-.69-.63-1.4-.94-2.12a.43.43 0 01-.05-.13c-.5-1.23-1-2.48-1.38-3.75-.64-1.9-1.19-3.88-1.64-5.84a40.44 40.44 0 01-.74-4.14 2.23 2.23 0 010-.23.4.4 0 000-.11 58.17 58.17 0 0118-50.86c.73 1.45 31.62 62.41 81.06 91.37 0 0-42.8-31.31-69-100A58.28 58.28 0 01165 262.73a.77.77 0 00.06.23c0 .14.07.35.13.58.16.77.46 2 .9 3.78 4.23 16.86 21.85 75.92 64.85 98.8 0 0-39.4 10.17-82.75 2.34a148.57 148.57 0 01-29.25-8.28 3.16 3.16 0 01-.43-.16l-2.06-.85C86 346.9 69.5 327.26 60.71 311.51zM344.46 321.49c-.17.22-.32.45-.47.65l-.08.1c-.31.49-.61 1-.94 1.45a42.47 42.47 0 01-2.91 4c-.07.08-.12.18-.2.26l-.08-.2 2.22-3a82.004 82.004 0 01-3.73 4.44l.44.22c-.49.58-1 1.16-1.54 1.74a.22.22 0 01-.09.1c-.9 1-1.84 1.93-2.82 2.84a58 58 0 01-4.61 3.94 39.47 39.47 0 01-3.44 2.41.72.72 0 01-.19.13l-.09.06a58.16 58.16 0 01-53.74 5c1-1.27 43.31-54.95 48.77-112 0 0-10.38 52-61.71 104.66a58.28 58.28 0 01-2.92-90.87.72.72 0 00.19-.15c.12-.08.28-.21.47-.37.63-.46 1.66-1.27 3.05-2.4 13.52-10.93 59.67-51.78 62.33-100.41 0 0 25.81 31.46 36.95 74.08a148.54 148.54 0 014.79 30 3.41 3.41 0 01.05.46c0 .74 0 1.48.09 2.22 1.66 32.8-9.2 56.04-19.79 70.64z"
				/>
			</svg>
		</animated.span>
	)
}

export { Recycling_1 }
